module.exports = __webpack_public_path__ + "static/shuffle-06923b06830ef6bf0be11130d69ce7b1.mp3";